/**
 * MobileMenu.jsx
 * Created by michaelbray on 5/7/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { get } from 'lodash';

import * as Icons from '../../sharedComponents/icons/Icons';
import SearchInputContainer from '../../../containers/navigation/SearchInputContainer';
import DropdownMenuItems from '../../../components/navigation/account/DropdownMenuItems';

import * as loginActions from '../../../actions/navigation/loginActions';
import * as SecurityHelper from '../../../helpers/securityHelper';

const propTypes = {
    logout: PropTypes.func,
    showLoginModal: PropTypes.func,
    account: PropTypes.shape({
        account_id: PropTypes.string,
        cell_phone: PropTypes.string,
        email: PropTypes.string,
        emergency_contact: PropTypes.shape({
            first_name: PropTypes.string,
            last_name: PropTypes.string,
            phone: PropTypes.string
        }),
        favorites: PropTypes.array,
        first_name: PropTypes.string,
        home_address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            city: PropTypes.string,
            state: PropTypes.string,
            zip_code: PropTypes.string
        }),
        home_phone: PropTypes.string,
        is_commercial_account: PropTypes.bool,
        last_name: PropTypes.string,
        legacy_account: PropTypes.bool,
        passes: PropTypes.array,
        phone_alerts: PropTypes.bool,
        profile_picture_id: PropTypes.string,
        sms_alerts: PropTypes.bool,
        trip_preferences: PropTypes.array
    }),
    cart: PropTypes.shape({
        account_id: PropTypes.string,
        discount: PropTypes.string,
        err_message: PropTypes.string,
        expiration: PropTypes.string,
        hasError: PropTypes.bool,
        reservations: PropTypes.array,
        showSessionWarning: PropTypes.bool,
        showTimer: PropTypes.bool,
        subtotal: PropTypes.string,
        tax: PropTypes.string,
        total: PropTypes.string
    })
};

const defaultProps = {
    cart: {},
    account: {}
};

const searchInputQueryParam = 'headerTextQuery';

export class MobileMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            logIn: false,
            profilePictureURL: ''
        };

        this.showLoginModal = this.showLoginModal.bind(this);
        this.handleToggleLogIn = this.handleToggleLogIn.bind(this);
    }

    componentDidMount() {
        this.getProfilePicture();
    }

    componentDidUpdate(prevProps) {
        const currentProfilePictureId = get(this.props, 'account.profile_picture_id');
        const prevProfilePictureId = get(prevProps, 'account.profile_picture_id');

        if (currentProfilePictureId && currentProfilePictureId !== prevProfilePictureId) {
            this.getProfilePicture();
        }
    }

    getProfilePicture = async () => {
        const id = get(this.props, 'account.profile_picture_id');

        if (!id) {
            return;
        }

        try {
            const url = `${process.env.API}/media/external/${id}`;
            const options = { headers: { Authorization: SecurityHelper.getAuthHeader() } };
            const response = await axios.get(url, options);

            this.setState({
                profilePictureURL: response.data.url
            });
        }
        catch {
            this.setState({
                profilePictureURL: ''
            });
        }
    }

    handleToggleLogIn() {
        this.setState((prevState) => {
            return {
                logIn: !prevState.logIn
            };
        });
    }

    showLoginModal() {
        this.props.showLoginModal();
    }

    renderSignInOrAccountPanel() {
        if (this.props.account !== null) {
            const firstName = this.props.account.first_name;

            let fullName = firstName;
            if (this.props.account.last_name.length > 0) {
                fullName = `${firstName} ${this.props.account.last_name[0]}.`;
            }

            let accountImage = <div className="nav-mobile-user-icon"><Icons.IconAccountCircle /></div>;
            if (this.state.profilePictureURL) {
                accountImage = <img src={this.state.profilePictureURL} alt={fullName} />;
            }

            return (
                <div>
                    <div className="nav-mobile-user-profile-head">
                        {fullName}
                        {accountImage}
                    </div>

                    <DropdownMenuItems
                        commercialAccount={this.props.account.is_commercial_account}
                        signOut={this.props.logout} />
                </div>
            );
        }

        let logInActiveClass = "";
        if (this.state.logIn) {
            logInActiveClass = "nav-mobile-menu-log-in-active";
        }

        return (
            <button
                className={`nav-mobile-menu-row ${logInActiveClass}`}
                title="Sign Up / Log In"
                aria-label="Sign Up / Log In"
                type="button"
                onClick={() => this.showLoginModal()}>
                Sign Up / Log In
                <span className="nav-mobile-menu-row-icon">
                    <Icons.IconAccountCircle />
                </span>
            </button>
        );
    }

    render() {
        const signInOrAccountPanel = this.renderSignInOrAccountPanel();

        return (
            <div
                className="nav-mobile-menu"
                id="nav-mobile-menu-id">
                <div className="nav-mobile-menu-inner">
                    <div className="nav-mobile-menu-body">
                        <SearchInputContainer
                            ariaLabel="Mobile menu search"
                            queryCriteriaPropertyName={searchInputQueryParam}
                            searchInputID="mobile-menu-search-input" />

                        <div className="nav-mobile-menu-account-panel">
                            {signInOrAccountPanel}
                        </div>

                        <a
                            className="nav-mobile-menu-row"
                            href="https://recreationonestopprod.service-now.com/external"
                            target="_blank"
                            aria-label="Help"
                            rel="noopener noreferrer">
                            Help
                            <span className="nav-mobile-menu-row-icon">
                                <Icons.IconHelp />
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

MobileMenu.propTypes = propTypes;
MobileMenu.defaultProps = defaultProps;

export default connect(
    (state) => ({
        modal: state.modal
    }),
    (dispatch) => bindActionCreators(loginActions, dispatch)
)(MobileMenu);
